import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";
const EndPage = () => {
  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}
      >
        {" "}
        The registration period has been ended.
        <br></br>登記時段已經結束。
      </Typography>
    </Box>
  );
};

export default EndPage;
